import { render, staticRenderFns } from "./historyOwners.vue?vue&type=template&id=1ed34ccb"
import script from "./historyOwners.vue?vue&type=script&lang=js"
export * from "./historyOwners.vue?vue&type=script&lang=js"
import style0 from "./historyOwners.vue?vue&type=style&index=0&id=1ed34ccb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports